function handleClickLink(event) {
	event.preventDefault();
	const block = event.target.dataset.block;
	var item = document.querySelectorAll(".js-navtabs-link");
	var itemContent = document.querySelectorAll(".js-navtabs-content");
	var i;
	for (i = 0; i < item.length; i++) {
		item[i].parentNode.classList.remove("active");
	}
	for (i = 0; i < itemContent.length; i++) {
		itemContent[i].classList.remove("active");
	}
	document.getElementById(block).classList.add("active");
	var element = document.getElementById(block);
    var headerOffset = 90;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
	window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
	}); 
	event.currentTarget.parentNode.className += " active";
}

document.querySelectorAll('.js-navtabs-link').forEach((elem) => {
	elem.addEventListener('click', handleClickLink);
});